module.exports = require('./helpers/bundle-url').getBundleURL('lbB2N') + "google-pay.74d42a48.svg";